<div class="map-wrapper">
    <app-flight-watch
    [showBreadcrumb]="false"
    [showFilters]="false"
    [showLegend]="false"
    [isLobbyView]="true"
></app-flight-watch>
</div>
